// Each user pops into a seat with a plus badge, the organization reaches out to it, and the badge turns into a check.
const NS = 'http://www.w3.org/2000/svg'
const DOOR = [166, 128]
const USERS = [
  {at: [256, 125], via: [211, 125], tint: '#8fc0fa'},
  {at: [304, 64], via: [228, 54], tint: '#7fb2f5'},
  {at: [304, 186], via: [228, 196], tint: '#a3ccfb'},
]
// LEAD holds the empty opening frame before the first one arrives.
const LEAD = 1
// HOLD keeps every user in place for a while before the scene fades and starts over.
const STEP = 2.2, HOLD = 18.25, END = USERS.length * STEP + 1.2 + HOLD, CYCLE = LEAD + END + 1.1

const el = (tag, attrs, parent) => {
  const e = document.createElementNS(NS, tag)
  for (const k in attrs) e.setAttribute(k, attrs[k])
  parent.append(e)
  return e
}
const clamp = (x, a = 0, b = 1) => Math.min(b, Math.max(a, x))
const back = t => 1 + 2.7 * Math.pow(t - 1, 3) + 1.7 * Math.pow(t - 1, 2)

function build(svg) {
  const users = USERS.map(u => ({...u}))
  const part = name => svg.querySelector(`.${name}`)

  users.forEach(u => {
    const d = `M${DOOR}Q${u.via} ${u.at}`
    u.link = el('path', {class: 'link', pathLength: 1, d}, part('links'))
    u.pulse = el('path', {class: 'pulse', pathLength: 1, d}, part('links'))
    u.seat = el('circle', {class: 'seat', cx: u.at[0], cy: u.at[1], r: 26}, part('seats'))
    u.g = el('g', {}, part('users'))
    el('circle', {r: 26, fill: '#e6eefc'}, u.g)
    const face = el('g', {'clip-path': 'url(#organization-add-user-face)'}, u.g)
    el('circle', {cy: -6, r: 10, fill: u.tint}, face)
    el('ellipse', {cy: 24, rx: 21, ry: 15, fill: u.tint}, face)
    u.ring = el('circle', {r: 26, fill: 'none', stroke: '#3fae6a', 'stroke-width': 2}, u.g)
    u.badge = el('g', {}, u.g)
    el('circle', {r: 10, fill: '#3fae6a', stroke: '#fff', 'stroke-width': 2}, u.badge)
    u.plus = el('path', {d: 'M-4.5 0h9M0 -4.5v9', fill: 'none', stroke: '#fff', 'stroke-width': 2.2, 'stroke-linecap': 'round'}, u.badge)
    u.tick = el('path', {d: 'M-4.2 0.3l3 3 5.4-6', fill: 'none', stroke: '#fff', 'stroke-width': 2.2, 'stroke-linecap': 'round', 'stroke-linejoin': 'round'}, u.badge)
  })

  return {users, org: part('org'), wins: [...svg.querySelectorAll('.wins .win')]}
}

function draw({users, org, wins}, t) {
  const fade = 1 - clamp((t - END) / 0.6)
  let glow = 0

  users.forEach((u, i) => {
    const t0 = i * STEP
    const pop = clamp((t - t0) / 0.45), badge = clamp((t - t0 - 0.3) / 0.35), link = clamp((t - t0 - 0.65) / 0.5)
    const up = clamp((t - t0 - 0.75) / 0.65), done = clamp((t - t0 - 1.35) / 0.3)

    u.g.setAttribute('transform', `translate(${u.at}) scale(${(pop > 0 ? back(pop) * (0.6 + 0.4 * fade) : 0).toFixed(3)})`)
    u.g.setAttribute('opacity', fade.toFixed(3))
    u.badge.setAttribute('transform', `translate(19 19) scale(${(badge > 0 ? back(badge) + 0.18 * Math.sin(done * Math.PI) : 0).toFixed(3)})`)
    u.plus.setAttribute('transform', `rotate(${(done * 90).toFixed(1)})`)
    u.plus.setAttribute('opacity', (1 - done).toFixed(3))
    u.tick.setAttribute('opacity', done.toFixed(3))
    u.ring.setAttribute('opacity', done.toFixed(3))
    u.link.setAttribute('stroke-dasharray', `${link.toFixed(3)} 2`)
    u.link.setAttribute('opacity', fade.toFixed(3))
    u.pulse.setAttribute('stroke-dasharray', '0.3 2')
    u.pulse.setAttribute('stroke-dashoffset', (0.3 - up * 1.3).toFixed(3))
    u.pulse.setAttribute('opacity', (up > 0 && up < 1 ? Math.sin(up * Math.PI) : 0).toFixed(3))
    u.seat.setAttribute('opacity', (pop > 0 ? 1 - fade : 1).toFixed(3))
    glow = Math.max(glow, Math.sin(clamp((t - t0 - 1.25) / 0.5) * Math.PI))
  })

  org.setAttribute('transform', `translate(122 166) scale(${(1 + 0.045 * glow).toFixed(4)}) translate(-122 -166)`)
  wins.forEach((w, i) => {
    const twinkle = 0.55 + 0.25 * Math.sin(t * 1.3 + i * 2.1)
    w.setAttribute('opacity', Math.min(1, twinkle + glow * 0.6).toFixed(3))
    w.style.fill = glow > 0.05 ? `color-mix(in srgb, #3fae6a ${Math.round(glow * 70)}%, #3f7fd6)` : ''
  })
}

let Hooks = {}

Hooks['Animations.OrganizationAddUser'] = {
  mounted() {
    const scene = build(this.el)

    // One user with a plus badge, held still.
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return draw(scene, 0.7)

    const start = performance.now()
    const frame = now => {
      draw(scene, ((now - start) / 1000) % CYCLE - LEAD)
      this.raf = requestAnimationFrame(frame)
    }
    this.raf = requestAnimationFrame(frame)
  },

  destroyed() {
    cancelAnimationFrame(this.raf)
  }
}

export {Hooks}
